<template> 
    <v-container fluid class="fill-height">
        <v-row>
            <v-col>
                <SupervisorLists></SupervisorLists>
            </v-col>

            <v-col>
                <!-- <div
                    class="align-items-center clickable my-3"
                >
                    <v-icon x-small color="primary">mdi-circle</v-icon>
                    <span class="font-weight-bold primary--text">
                        Create Case from PMS
                    </span>
                </div> -->
                <CreatePMSCase></CreatePMSCase>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <DoctorComponent></DoctorComponent>
            </v-col>
        </v-row>
        <v-row v-show="false">
            <v-col>
                {{ test }} {{ test2 }} {{ test3 }}
                <!-- <drop
                    @dragover="event1()"
                    @dragleave="event2()"
                    @drop="testEvet()"
                    @click="event4()"
                    class="drop"
                > -->
                <drop
                    @drop="testEvet($event, 2)"
                    class="drop"
                >
                    Dropzone

                </drop>

                <drag class="drag" :transfer-data="{ draggable }">{{ draggable }}</drag>
                <drop class="drop" @drop="handleDrop">Dropzone</drop>

                <drop class="drop" @drop="handleDrop2">Dropzone</drop>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import DASHBOARD_STORE from "../store/dashboard.module";

export default {
    components: {
        SupervisorLists: () => import("../partials/SupervisorLists"),
        DoctorComponent: () => import("../doctor/DoctorComponent"),
        CreatePMSCase: () => import("../partials/CreatePMSCase")
    },
    data: () => ({
        draggable: 'Drag Me'
    }),
    computed: {
        test() {
            return DASHBOARD_STORE.state.test;
        },
        test2() {
            return DASHBOARD_STORE.state.selectedCase;
        },
        test3() {
            return DASHBOARD_STORE.getters.showCaseDetails;
        }
    },
    methods: {
        event1(event) {
            console.log(event, "event1");
        },
        event2(event) {
            console.log(event, "event2");
        },
        testEvet(data, event) {
            console.log(data, event, "event3");
        },
        event4(event) {
            console.log(event, "event4");
        },
        handleDrop(data, event) {
            console.log({ data, event });
            // alert(`You dropped with data: ${JSON.stringify(data)}`);
        },
        handleDrop2(event) {
            console.log({  event });
            // alert(`You dropped with data: ${JSON.stringify(data)}`);
        },
    }
}
</script>

<style lang="scss" scoped>
.drag,
.drop {
  font-family: sans-serif;
  display: inline-block;
  border-radius: 10px;
  background: #ccc;
  position: relative;
  padding: 30px;
  text-align: center;
  vertical-align: top;
}

.drag {
  color: #fff;
  cursor: move;
  background: #777;
  border-right: 2px solid #555;
  border-bottom: 2px solid #555;
}

.drop {
  background: #eee;
  border-top: 2px solid #ccc;
  border-left: 2px solid #ccc;
}

</style>